import { actionTypes } from '../actionTypes';
import { IProductionSpeedState } from '../../model/productionSpeed';
import {
  filterProductionSpeedReportData, getSalesRepData
} from './productionSpeedFilters'

export const productionSpeedReducer = (state: IProductionSpeedState[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_PRODUCTION_SPEED_SUCCESS:
      return {
        ProductionSpeedReportData: filterProductionSpeedReportData(action.payload)
      }
      case actionTypes.LOAD_PRODUCTION_SPEED_FILTER_SUCCESS:
      return {
        SalesRep: getSalesRepData(action.payload)
      }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/productionSpeed/reducer.ts